export default __webpack_public_path__ + "4aedc032ed65f4743b34dc0e1edee8c8.svg";